import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import moment from "moment";

Vue.use(Vuex);
//flatten nested subvisits from available events
function flat(array) {
  var result = [];
  array.forEach(function(a) {
    result.push(a);
    if (Array.isArray(a.subvisits)) {
      result = result.concat(flat(a.subvisits));
    }
  });
  return result.filter((item) => !item.subvisits);
}
export default new Vuex.Store({
  state: {
    isAuth: false,
    loading: {
      appointmentSearch: false,
      appointmentScheduling: false,
      patientLoad: false,
    },
    error: {
      appointmentScheduling: {
        message: null,
      },
      login: {
        unassigned: false,
      },
      form: {
        details: false,
      },
      initialPatientLoad: false,
    },
    alerts: {
      lafayetteParking: true,
    },
    person: {
      name: null,
      status: null,
      sex: null,
      location: null,
      dentalLocation: null,
      isDentalEstablished: null,
      age: null,
      appointments: [],
      recallPlans: [],
    },
    events: [],
    recallPlans: [],
    locations: [],
    documents: [],
    resources: {
      covid: [
        //Lafayette
        {
          locationId: "E25D95D3-CCA5-4B10-A395-E8534046B6CF",
          resourceId: "371CBC19-D87F-4221-BFA9-541D23517A88",
        },
        //Thornton
        {
          locationId: "14A1B866-8393-4510-8144-A45B5C4FD07D",
          resourceId: "E528DEBF-E3B2-4EF0-AE67-613794803CD2",
        },
        //Pecos
        {
          locationId: "6136FDE9-9724-4A93-9DE4-9CC6B1C7C0AA",
          resourceId: "D44747B2-F6A3-4F71-8612-6B675983E8DA",
        },
        //Peoples
        {
          locationId: "1A1F56D0-44AF-4F83-8771-5CC47AF6157C",
          resourceId: "F6BA5217-7157-4C5C-A504-E43E4E9914D4",
        },
        //Westminster
        {
          locationId: "B7FC3502-77B4-45F8-B92D-D3826ED3CE33",
          resourceId: "955C20DC-9752-4C5C-BAB6-22F19B183699",
        },
      ],
      flu: [
        //Lafayette
        {
          locationId: "E25D95D3-CCA5-4B10-A395-E8534046B6CF",
          resourceId: "7BC63A5F-9DE3-4A96-8B59-8B3F92317DAD",
        },
        //Thornton
        {
          locationId: "14A1B866-8393-4510-8144-A45B5C4FD07D",
          resourceId: "B6CD2B72-1B6A-4E5F-86AB-5F7CEB296AA4",
        },
        //Pecos
        {
          locationId: "6136FDE9-9724-4A93-9DE4-9CC6B1C7C0AA",
          resourceId: "52A8141B-1017-4FF2-9F27-9F6F5BF1F18A",
        },
        //Peoples
        {
          locationId: "1A1F56D0-44AF-4F83-8771-5CC47AF6157C",
          resourceId: "3C7AFE75-EFA2-4CAB-9123-6227FAC5994F",
        },
        //Westminster
        {
          locationId: "B7FC3502-77B4-45F8-B92D-D3826ED3CE33",
          resourceId: "B66029D7-2AEC-42A1-A762-58A9194BE108",
        },
        //Gilpin
        {
          locationId: "BB666A55-04B3-4255-A7FB-C09C85E29990",
          resourceId: "6262D059-102C-4A1A-9B30-9426050C4139",
        },
        //Nederland
        {
          locationId: "80597AA4-E3CF-496A-8CF9-AC6B31191777",
          resourceId: "3D0B51E1-9AAA-40C6-948D-E86869120647",
        },
      ],
      hoyl: [
        //Lafayette
        {
          locationId: "E25D95D3-CCA5-4B10-A395-E8534046B6CF",
          resourceId: "A6903F0D-6FB9-4864-B190-5799E1B86E02",
        },
        // Nederland
        {
          locationId: "80597AA4-E3CF-496A-8CF9-AC6B31191777",
          resourceId: "40A4EF07-248C-4210-ABE0-B4FADA2332DD",
        },
        // Gilpin
        {
          locationId: "BB666A55-04B3-4255-A7FB-C09C85E29990",
          resourceId: "E54A14DF-E759-48D4-945C-4F0FBC8735CA",
        },
      ],
      hirman: [
        //Lafayette
        {
          locationId: "E25D95D3-CCA5-4B10-A395-E8534046B6CF",
          resourceId: "B971025A-3D38-467B-9076-A941E0036B01",
        },
        // Nederland
        {
          locationId: "80597AA4-E3CF-496A-8CF9-AC6B31191777",
          resourceId: "E64C1D74-45A2-4D7D-8779-01B81B999426",
        },
        // Gilpin
        {
          locationId: "BB666A55-04B3-4255-A7FB-C09C85E29990",
          resourceId: "264CFD43-9CB6-4577-A1F6-42C50081BEEA",
        },
      ],
      hirmanAndHoyl: [
        //Lafayette
        {
          locationId: "E25D95D3-CCA5-4B10-A395-E8534046B6CF",
          resourceId: "B971025A-3D38-467B-9076-A941E0036B01",
        },
        // Nederland
        {
          locationId: "80597AA4-E3CF-496A-8CF9-AC6B31191777",
          resourceId: "E64C1D74-45A2-4D7D-8779-01B81B999426",
        },
        // Gilpin
        {
          locationId: "BB666A55-04B3-4255-A7FB-C09C85E29990",
          resourceId: "264CFD43-9CB6-4577-A1F6-42C50081BEEA",
        },
        //Lafayette
        {
          locationId: "E25D95D3-CCA5-4B10-A395-E8534046B6CF",
          resourceId: "A6903F0D-6FB9-4864-B190-5799E1B86E02",
        },
        // Nederland
        {
          locationId: "80597AA4-E3CF-496A-8CF9-AC6B31191777",
          resourceId: "40A4EF07-248C-4210-ABE0-B4FADA2332DD",
        },
        // Gilpin
        {
          locationId: "BB666A55-04B3-4255-A7FB-C09C85E29990",
          resourceId: "E54A14DF-E759-48D4-945C-4F0FBC8735CA",
        },
        {
          resourceId: "f7acd597-2353-4087-ab48-ce3cc5520255",
          locationId: "E25D95D3-CCA5-4B10-A395-E8534046B6CF",
        },
      ],
    },
    appointmentSelection: {
      activeRecall: "",
      event: "",
      visit: "",
      resource: "",
      location: "",
      appointment: {},
      covidScreen: "",
      firstAvailableDate: new Date().toISOString().substr(0, 10),
      lastSearchedParams: "",
      searchedAppointments: [],
      nextAvailableAppointments: "",
      activeTab: "",
      exitGuard: true,
      searchedAppointmentsForCrossLocationProviders: [],
      crossLocationProviderAppointments: false,
      locationAndResourceSelected: false,
    },
  },
  mutations: {
    setLoader(state, { type, isLoading }) {
      state.loading[type] = isLoading;
    },
    setLocations(state, data) {
      state.locations = data;
    },
    setSelectedEvent(state, data) {
      state.appointmentSelection.event = data;
    },
    setSelectedVisit(state, data) {
      state.appointmentSelection.visit = data;
      state.appointmentSelection.location = "";
    },
    setAuth(state, data) {
      state.isAuth = data;
    },
    updateLocation(state, data) {
      state.person.location = data;
    },
    setDocuments(state, data) {
      state.documents = data;
    },
    setPerson(state, data) {
      if (data.pcp.lastName == "Hoyl") {
        state.person.pod = data.pod;
        state.person.pcp = data.pcp;
        state.person.pcpFull = `${data.pcp.firstName}${data.pcp.lastName}`;
      }
      // if (data.pcp.lastName == "Hirman") {
      //   state.person.pod = data.pod;
      //   state.person.pcp = data.pcp;
      //   state.person.pcpFull = `${data.pcp.firstName}${data.pcp.lastName}`;
      // }
      state.person.status = data.status;
      state.person.sex = data.sex;
      state.person.location = data.location;
      state.person.dentalLocation = data.dentalLocation;
      state.person.isDentalEstablished = data.isDentalEstablished;
      state.person.name = data.name;
      state.person.age = data.age;
      state.person.statusDescription = data.statusDescription;
    },
    setEvents(state, data) {
      state.recallPlans = data["recalls"];

      function filterSubvisits(subvisits) {
        return subvisits.filter(
          (subvisit) =>
            subvisit.description !== "Virtual/Video Visit" &&
            subvisit.description !== "Phone Visit"
        );
      }

      const keepCrossLocation = Boolean(state.person.pcpFull);

      const filteredData = data["all"].filter((item) => {
        if (!item.subvisits || item.subvisits.length === 0) return true;
        return item.subvisits.some((subvisit) =>
          keepCrossLocation
            ? subvisit.crossLocationProviders !== false
            : subvisit.crossLocationProviders !== true
        );
      });

      data["all"] = state.person.isDentalEstablished
        ? filteredData
        : filteredData.filter(
            (event) => !event.description?.includes("Dental")
          );

      if (state.person.statusDescription === "Full Pay – Declined") {
        data.all[1].subvisits = filterSubvisits(data.all[1].subvisits);
        data.all[2].subvisits = filterSubvisits(data.all[1].subvisits);
      }

      state.events =
        data[state.person?.location?.split(" ")[1].toLowerCase()] ||
        data["all"];
    },
    setLocationAndResourceSelected(state) {
      state.appointmentSelection.locationAndResourceSelected = true;
    },
    setNextAvailableAppointments(state, data) {
      state.appointmentSelection.nextAvailableAppointments = data;
      if (state.appointmentSelection.visit.crossLocationProviders) {
        state.appointmentSelection.crossLocationProviderAppointments = true;
      }
    },
    setSelectedAppointment(state, data) {
      state.appointmentSelection.appointment = data;
    },
    setSearchedAppointments(state, data) {
      state.appointmentSelection.searchedAppointments = data;
    },
    setSearchedAppointmentsForCrossLocationProviders(state, data) {
      state.appointmentSelection.searchedAppointmentsForCrossLocationProviders = data;
    },
    setAppointments(state, data) {
      if (data.length > 0) {
        let copyEvents = JSON.parse(JSON.stringify(state.events));
        let events = flat(copyEvents);
        //prevent naming conflict of id in both arrays
        events = events.map(function(item) {
          item.eventId = item.id;
          delete item.id;
          return item;
        });
        let appointments = data
          .map((x) =>
            Object.assign(
              x,
              events.find(
                (y) =>
                  y.eventId.toLowerCase() === x.eventId.toLowerCase() ||
                  x.resourceId.toLowerCase() === y.resourceIds
              )
            )
          )
          .map((item) => {
            /* map resources that are tied to events to
          differentiate multiple resources that are tied to 1 event */
            let mappedResource = item.resourceIds
              ? item.resourceIds
                  .map((x) => {
                    if (x.id.toLowerCase() === item.resourceId.toLowerCase()) {
                      return x;
                    } else return;
                  })
                  .filter((item) => item)[0]
              : null;
            return {
              checkIn: item.checkIn || 20,
              mappedResource: mappedResource || {},
              ...item,
            };
          });
        state.person.appointments = appointments;
      } else {
        state.person.appointments = [];
      }
    },
    setRecallPlans(state, data) {
      state.person.recallPlans = data;
    },
    resetSearchedAppointments(state) {
      state.appointmentSelection.appointment = "";
      state.appointmentSelection.searchedAppointments = [];
    },
    resetSearchedAppointmentsForCrossLocationProviders(state) {
      state.appointmentSelection.searchedAppointmentsForCrossLocationProviders = [];
    },
    resetAppointmentSelection(state) {
      state.appointmentSelection = {
        activeRecall: "",
        event: "",
        visit: "",
        resource: "",
        location: "",
        appointment: {},
        covidScreen: "",
        firstAvailableDate: new Date().toISOString().substr(0, 10),
        lastSearchedParams: "",
        searchedAppointments: [],
        nextAvailableAppointments: "",
        activeTab: "",
        exitGuard: true,
        searchedAppointmentsForCrossLocationProviders: [],
        crossLocationProviderAppointments: false,
        locationAndResourceSelected: false,
      };
    },
    resetNextAvailableAppointments(state, data) {
      state.appointmentSelection.nextAvailableAppointments = "";
      state.appointmentSelection.crossLocationProviderAppointments = false;
    },
    setAppointmentResource(state, data) {
      state.appointmentSelection.resource = data;
    },
    setAppointmentLocation(state, data) {
      state.appointmentSelection.location = data;
    },
    resetSelectedResource(state) {
      state.appointmentSelection.resource = "";
    },
    resetSelectedLocation(state) {
      state.appointmentSelection.location = "";
    },
    resetLocationAndResourceSelected(state) {
      state.appointmentSelection.locationAndResourceSelected = false;
    },
    resetEvent(state) {
      state.appointmentSelection.event = "";
      state.appointmentSelection.visit = "";
    },
    erasePerson(state) {
      state.person = {
        name: null,
        status: null,
        sex: null,
        location: null,
        age: null,
      };
    },
  },
  actions: {
    getResources({ state }) {
      return axios
        .post("/resources", {
          type: state.appointmentSelection.visit.type,
          location: state.person.location,
        })
        .then((response) => {
          return response.data;
        });
    },
    getDentalResources({ state }) {
      return axios
        .post("/resources/dental", {
          type: state.appointmentSelection.visit.type,
          location: state.person.dentalLocation,
        })
        .then((response) => {
          return response.data;
        });
    },
    getLocationResources({ state }) {
      return axios
        .post("/resources/location", {
          type: state.appointmentSelection.visit.type,
          location: state.appointmentSelection.resource.location,
          locationShortName: state.appointmentSelection.resource.shortName,
        })
        .then((response) => {
          return response.data;
        });
    },
    getFloatResources({ state }) {
      let location;
      switch (state.person.location) {
        case "Clinica Thornton":
          location = "Thornton";
          break;
        case "Clinica Lafayette":
          location = "Lafayette";
          break;
        case "Clinica Pecos":
          location = "Pecos";
          break;
        case "Clinica Westminster":
          location = "Westminster";
          break;
        case "Clinica Peoples":
          location = "Peoples";
          break;
        case "Clinica Alpine":
          location = "Alpine";
          break;
        case "Clinica Nederland":
          location = "Ned";
          break;
        case "Clinica Gilpin County":
          location = "Gilpin";
          break;
        default:
          break;
      }
      return axios
        .post("/resources/float", {
          type: state.appointmentSelection.visit.type,
          location: location,
        })
        .then((response) => {
          return response.data;
        });
    },
    getPersonAppointments({ commit }) {
      return axios.get("appointments").then((response) => {
        commit("setAppointments", response.data);
      });
    },
    async loadAppointments({ dispatch }, resources) {
      try {
        let appointments = [];
        for (let resource of resources) {
          let appointment = await dispatch("getAppointments", {
            locationId:
              resource.locationInfo?.locationId || resource.locationId,
            resourceId: resource.resourceId,
            count: 300,
            isPCP: resource.isPCP,
          });
          appointments.push(...appointment);
        }
        return appointments;
      } catch (error) {}
    },
    getAppointments({ state }, { locationId, count, resourceId, isPCP }) {
      let days = 14;
      if (state.appointmentSelection.visit.description == "Flu Vaccine") {
        days = 22;
      }
      if (isPCP) {
        days = 21;
      }
      return axios
        .post("appointments/availability", {
          eventId: state.appointmentSelection.visit.id,
          resourceId: resourceId,
          locationId: locationId,
          limit: count || 10,
          duration: state.appointmentSelection.visit.duration || "20",
          mode: state.appointmentSelection.visit.mode || "Person",
          days: days,
        })
        .then((response) => {
          state.appointmentSelection.lastSearchedParams = {
            floatVisit: state.appointmentSelection.visit.floatProviders
              ? true
              : false,
            crossLocationProviderVisit:
              state.appointmentSelection.visit.crossLocationProviders,
            visitId: state.appointmentSelection.visit.id,
            resourceId: resourceId,
            locationId: locationId,
            duration: state.appointmentSelection.visit.duration || "20",
            mode: state.appointmentSelection.visit.mode || "Person",
          };

          if (state.appointmentSelection.lastSearchedParams.floatVisit) {
            state.appointmentSelection.lastSearchedParams.visitId = "reset";
          }
          return response.data;
        });
    },
    scheduleAppointment({ state }) {
      return axios.post("/appointments", {
        eventId: state.appointmentSelection.visit.id,
        resourceId: state.appointmentSelection.resource.resourceId,
        providerId: state.appointmentSelection.resource.providerId,
        locationId: state.appointmentSelection.appointment.locationId,
        duration: state.appointmentSelection.visit.duration,
        appointmentDate:
          state.appointmentSelection.appointment.appointmentDateTime,
        details: `${
          state.appointmentSelection?.activeRecall?.description
            ? " " + state.appointmentSelection.activeRecall.description
            : ""
        }: ${state.appointmentSelection.appointment.details.substring(0, 150)}`,
        // covidScreen: state.appointmentSelection.appointment.covidScreen
        //   ? "53F552DD-EA18-4028-88D5-3D29F99EC95C"
        //   : "453C5E43-02AC-49BF-AD87-1CFCCC9D02DD",
      });
    },
    updateRecallPlan({ state }) {
      return axios.post("servicebus/recallplan", {
        id: state.appointmentSelection.activeRecall.id,
        recallPlanId: state.appointmentSelection.activeRecall.recallPlanId,
        practiceId: state.appointmentSelection.activeRecall.practiceId,
      });
    },
  },
  modules: {},
  getters: {
    getCurrentRecallPlans: (state) => {
      return state.person.recallPlans?.filter(
        (item) =>
          moment(item.expectedReturnDate).format("MM/DD/YYYY") >=
          moment().format("MM/DD/YYYY")
      );
    },
    getMappedAppointments: (state) => ({ resources, appointments }) => {
      let allResources = resources.map((itm) => ({
        ...appointments.find(
          (item) =>
            item.resourceIds[0].toUpperCase() === itm.resourceId.toUpperCase()
        ),
        ...itm,
      }));
      if (state.appointmentSelection.event.type == "Dental") {
        const found = allResources.find((obj) => !!obj?.appointmentDateTime);
        if (found) {
          return [found];
        }
      }

      return allResources;
    },
    getMappedAppointmentsBasedOnLocation: () => ({
      resources,
      appointments,
      location,
    }) => {
      return resources.map((itm) => ({
        ...appointments.find(
          (item) =>
            item.resourceIds[0].toUpperCase() ===
              itm.resourceId.toUpperCase() &&
            item.locationName.includes(location)
        ),
        ...itm,
      }));
    },
    getAvailableAppointmentDates: (state) => {
      if (state.appointmentSelection.resource.locationId) {
        return state.appointmentSelection.searchedAppointments
          .filter(
            (item) =>
              item.locationId.toLowerCase() ===
              state.appointmentSelection.resource.locationId.toLowerCase()
          )
          .map((item) => moment(item.appointmentDateTime).format("YYYY-MM-DD"));
      }
      return state.appointmentSelection.searchedAppointments.map((item) =>
        moment(item.appointmentDateTime).format("YYYY-MM-DD")
      );
    },
    getAssignedLocationInfo: (state) => {
      return state.locations.filter(
        (item) => item.location === state.person.location
      )[0];
    },
    mapMultiLocationResourcesToLocations: (state) => (resources) => {
      return state.resources[resources].map((x) =>
        Object.assign(
          x,
          state.locations.find((y) => y.locationId === x.locationId)
        )
      );
    },
    filteredDateAppointments: (state) => (locationId) => {
      /* get patient's current appointments and prevent back to back appointments from being scheduled */
      let appointments = state.appointmentSelection.searchedAppointments.filter(
        (appointment) =>
          moment(appointment.appointmentDateTime).format("YYYY-MM-DD") ===
          state.appointmentSelection.firstAvailableDate
      );
      //filter by location
      if (locationId) {
        appointments = appointments.filter(
          (item) => item.locationId.toLowerCase() === locationId.toLowerCase()
        );
      }
      /*handle patient appointment retrieval error */
      return appointments
        .map((item) => ({
          ...item,
          date: moment(item.appointmentDateTime).format("YYYY-MM-DD"),
          time: moment(item.appointmentDateTime).format("hhmm"),
        }))
        .filter((f) =>
          state.person.appointments.every((item) => {
            if (
              item.date == f.date &&
              item.time !== f.time &&
              f.time !==
                this.moment(item.time, "hhmm")
                  .add(20, "m")
                  .format("hhmm") &&
              f.time !==
                this.moment(item.time, "hhmm")
                  .subtract(20, "m")
                  .format("hhmm")
            ) {
              return item;
            } else if (item.date != f.date) {
              return item;
            }
          })
        );
    },
  },
});
